import { render } from "./Tfoot.vue?vue&type=template&id=19d8c664&lang=pug"
import script from "./Tfoot.vue?vue&type=script&setup=true&lang=js"
export * from "./Tfoot.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__